import { AlertTriangle, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export const ConflictBanner = ({ message, onReload, testId = "conflict-banner" }) => (
  <Alert variant="destructive" data-testid={testId} className="bg-card">
    <AlertTriangle className="h-4 w-4" />
    <AlertTitle>Endra av nokon andre</AlertTitle>
    <AlertDescription className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <span>{message || "Denne ordra vart endra av nokon andre. Last inn på nytt før du held fram."}</span>
      <Button size="sm" variant="outline" onClick={onReload} data-testid={`${testId}-reload-button`} className="bg-card">
        <RefreshCw className="mr-2 h-4 w-4" /> Last inn på nytt
      </Button>
    </AlertDescription>
  </Alert>
);
